<template>
    <div class="warpper">

        <div class="info-container flex flex-direction ">
            <div class="form-title">填写您的意见建议</div>
            <el-form class="flex flex-direction padding-sm" :model="ruleForm" :rules="rules" ref="ruleForm">
                <el-form-item prop="content">
                    <el-input v-model="ruleForm.content" placeholder="请输入意见建议" type="textarea" resize="none"
                              :autosize="{ minRows: 3, maxRows: 3 }">
                    </el-input>
                </el-form-item>
                <el-button class="operate self-end" :loading="loading" @click="submitForm('ruleForm')">
                    提交
                </el-button>
            </el-form>
        </div>
        <div class="info-container scroll flex flex-direction flex-sub margin-top-sm" ref="info">
            <empty v-if="lists.length === 0" :type="0"/>
            <div class="idea-item flex flex-direction " v-for="(item,index) in lists" :key="index">
                <div class="time">{{item.add_time}}</div>
                <div class="question">{{item.content}}</div>
                <div class="answer" v-if="item.remark">系统回复：{{item.remark}}</div>
            </div>
        </div>

    </div>
</template>

<script>
    import {addMessage, getMessageList} from '@/api/member'
    import {zhDate} from '@/utils/utils'
    export default {
        name: "idea",
        components: {},
        data() {
            return {
                lists: [],
                ruleForm: {
                    content: '',
                },
                rules: {
                    content: [
                        {required: true, message: '请输入意见建议', trigger: 'blur'},
                        {min: 5, message: '意见建议至少为 5 个字符', trigger: 'blur'}
                    ]
                },
                loading: false,
            }
        },
        created() {
            this.$emit('setIndex', 2, '意见建议')
            this.init()
        },
        computed: {
            user() {
                return this.$store.state.user
            }
        },
        methods: {
            async init() {
                let _data = await getMessageList()
                if (_data.status === 200) {
                    _data.data.map(item=>{
                        item.add_time = zhDate(item.add_time * 1000)
                    })
                    this.lists = _data.data
                }
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.addMessage();
                    }
                });
            },
            async addMessage() {
                this.loading = true
                let _data = await addMessage(this.ruleForm.content)
                this.loading = false
                if (_data.status === 200) {
                    this.$refs['ruleForm'].resetFields()
                    this.$message.success(_data.msg)
                    this.$parent.$parent.scrollTo()
                    this.init()
                }
            },
        }

    }
</script>

<style scoped lang="scss">
    .warpper {
        .info-container {
            background-color: #ffffff;
            border-radius: 10px;
            min-height: 160px;
            &.scroll {
                padding: 10px;
                overflow-y: scroll;
                &::-webkit-scrollbar {
                    display: none
                }
            }
            .idea-item{
                background-color: #f3f7fb;
                border-radius: 10px;
                padding: 21px 25px;
                margin-top: 10px;
                .time{
                    font-size: 14px;
                    color: #7b8ba5;
                }
                .question{
                    font-size: 18px;
                    line-height: 22px;
                    font-weight: bold;
                    color: #0a2240;
                    margin-top: 10px;
                }
                .answer{
                    background-color: #ffffff;
                    border-radius: 10px;
                    padding: 22px 27px;
                    font-size: 16px;
                    line-height: 22px;
                    color: #7b8ba5;
                    margin-top: 10px;
                }
            }
            .form-title {
                height: 36px;
                line-height: 36px;
                background-color: #f3f7fb;
                border-radius: 10px 10px 0 0;
                font-size: 18px;
                font-weight: bold;
                color: #0a2240;
                padding: 0 24px;
            }
            .operate {
                width: 99px;
                height: 40px;
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#ff9600, #ff9600);
                background-blend-mode: normal, normal;
                border-radius: 20px;
                font-size: 16px;
                color: #ffffff;
            }
        }
    }
</style>